import React, { FC, ReactNode } from 'react';

import { CustomIcons } from '@nhl/nhl-breakaway-ui';

import {
    NoContentContainer,
    NoContentMessageWrapper,
    ViewHighlightsMessageWrapper,
    ZamboniIconContainer,
} from './styles';

type NoGamesPropTypes = {
    className?: string;
    primaryText: ReactNode;
    secondaryText?: ReactNode;
    icon?: ReactNode;
};

const NoContent: FC<NoGamesPropTypes> = ({ className, primaryText, secondaryText, icon }) => (
    <NoContentContainer className={className}>
        <ZamboniIconContainer>{icon || <CustomIcons.ZamboniIcon />}</ZamboniIconContainer>
        <NoContentMessageWrapper>{primaryText}</NoContentMessageWrapper>
        {secondaryText && <ViewHighlightsMessageWrapper>{secondaryText}</ViewHighlightsMessageWrapper>}
    </NoContentContainer>
);

export default NoContent;
